import PropTypes from "prop-types"
import classNames from "classnames"
import { StarRounded, Link } from "@mui/icons-material"
import { TableRow, TableCell } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { numberFormatter } from "helpers/formatters/numbers"
import { getFactorDisabled } from "helpers/factors"
import { THRESHOLD_PARAMS, computeThresholdIcon } from "helpers/threshold"
import ThresholdIcon from "components/threshold-icon"
import { get } from "lodash"

function computeValueAndIconCell(thresholdParams, value) {
  let iconComponent
  let tooltip
  if (thresholdParams) {
    const thresholdIcon = computeThresholdIcon(value, thresholdParams)
    iconComponent = <ThresholdIcon threshold={get(thresholdIcon, "icon")} />
    tooltip = get(thresholdIcon, "tooltip")
  }

  const content = <div className="factor-value-wrapper">
    {iconComponent}
    {numberFormatter(value)}
  </div>

  if (tooltip) {
    return <Tooltip classes={{ popper: "security-profile-drift", tooltip: "drift-tooltip" }} title={tooltip}>
      {content}
    </Tooltip>
  }
  return content
}

export default function DetailRow({ value, thresholdParams, openFactorProfile }) {
  return <TableRow className={classNames("detail-row", { favorite: value.favorite })}>
    <TableCell className="name" component="th" scope="row">
      <div className="factor-link-wrapper">
        <StarRounded className="star-icon" />
        {!getFactorDisabled(value.category)
          ? <a onClick={() => openFactorProfile(value.id)}>{value.label}{!!value.secondaryLabel && <span className="secondary"> - {value.secondaryLabel}</span>}<Link className="icon" /></a>
          : <span>{value.label}{!!value.secondaryLabel && <span className="secondary">&nbsp;- {value.secondaryLabel}</span>}</span>}
      </div>
    </TableCell>
    <TableCell align="right">
      {computeValueAndIconCell(thresholdParams, value.value)}
    </TableCell>
  </TableRow>
}

DetailRow.propTypes = {
  value: PropTypes.object.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  thresholdParams: THRESHOLD_PARAMS,
}
